import React, { useState } from 'react';
interface MenuItem {
  title: string;
  url: string;
  children?: {
    title: string;
    url: string;
  }[];
}
const menuItems: MenuItem[] = [{
  title: 'Law Enforcement',
  url: '/law-enforcement-capabilities'
}, {
  title: 'Crisis Planning',
  url: '/crisis-management-planning'
}, {
  title: 'Corporate',
  url: '/corporate-critical-incidents-planning'
}, {
  title: 'Civilian',
  url: '/civilian-protection'
}, {
  title: 'Training',
  url: '/training'
}, {
  title: 'Resources',
  url: '/strategic-partners',
  children: [{
    title: 'Blog',
    url: '/blog'
  }]
}, {
  title: 'About',
  url: '/medina-tactical-dynamics',
  children: [{
    title: 'Meet the Founder',
    url: '/meet-the-founder'
  }]
}];
const socialLinks = [{
  href: 'https://www.youtube.com/channel/UCWe8nIgfZn-Lhny4k-Wn3Wg',
  label: 'YouTube',
  svg: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4" data-id="element-98">
        <path d="M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17" data-id="element-99" />
        <path d="m10 15 5-3-5-3z" data-id="element-100" />
      </svg>
}, {
  href: 'https://www.instagram.com/medinatactical360/',
  label: 'Instagram',
  svg: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4" data-id="element-101">
        <rect width="20" height="20" x="2" y="2" rx="5" ry="5" data-id="element-102" />
        <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" data-id="element-103" />
        <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" data-id="element-104" />
      </svg>
}, {
  href: 'https://www.facebook.com/TeamAPCUSA/',
  label: 'Facebook',
  svg: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4" data-id="element-105">
        <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" data-id="element-106" />
      </svg>
}, {
  href: 'https://www.linkedin.com/in/jose-medina-a84845a/',
  label: 'LinkedIn',
  svg: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4" data-id="element-107">
        <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" data-id="element-108" />
        <rect width="4" height="12" x="2" y="9" data-id="element-109" />
        <circle cx="4" cy="4" r="2" data-id="element-110" />
      </svg>
}];
interface MobileMenuProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
}
export function MobileMenu() {
  const [isOpen, setIsOpen] = useState(false);
  return <>
      <div className="lg:hidden flex items-center ml-auto" data-id="element-111">
        <button onClick={() => setIsOpen(!isOpen)} className="text-brand-gray-300 hover:text-brand-white focus:outline-none" data-id="element-112">
          {isOpen ? <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-6 w-6" data-id="element-113">
              <path d="M18 6 6 18" data-id="element-114" />
              <path d="m6 6 12 12" data-id="element-115" />
            </svg> : <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-6 w-6" data-id="element-116">
              <line x1="4" x2="20" y1="12" y2="12" data-id="element-117" />
              <line x1="4" x2="20" y1="6" y2="6" data-id="element-118" />
              <line x1="4" x2="20" y1="18" y2="18" data-id="element-119" />
            </svg>}
        </button>
      </div>

      {isOpen && <div className="lg:hidden bg-brand-gray-900 border-b border-brand-gray-800 absolute top-full left-0 right-0" data-id="element-120">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-121">
            {menuItems.map(item => <div key={item.title} data-id="element-122">
                <a href={item.url} className="block px-3 py-2 text-sm font-medium text-brand-gray-300 hover:text-brand-teal hover:bg-brand-gray-800 uppercase tracking-wider transition-colors" data-id="element-123">
                  {item.title}
                </a>
                {item.children?.map(child => <a key={child.title} href={child.url} className="block px-6 py-2 text-xs font-medium text-brand-gray-400 hover:text-brand-teal hover:bg-brand-gray-800 uppercase tracking-wider" data-id="element-124">
                    — {child.title}
                  </a>)}
              </div>)}
            <div className="px-3 py-2" data-id="element-125">
              <a href="/contact" className="inline-flex items-center justify-center w-full px-4 py-2 text-xs font-semibold uppercase tracking-wider bg-brand-teal text-brand-white border border-transparent hover:bg-brand-teal-light transition-all duration-200" data-id="element-126">
                Contact Us
              </a>
            </div>
            <div className="px-3 pt-4 mt-2 border-t border-brand-gray-800 flex items-center justify-between" data-id="element-127">
              <div className="flex items-center gap-4" data-id="element-128">
                {socialLinks.map(social => <a key={social.label} href={social.href} target="_blank" rel="noreferrer" aria-label={social.label} className="text-brand-gray-500 hover:text-brand-teal transition-colors" data-id="element-129">
                    {social.svg}
                  </a>)}
              </div>
              <a href="tel:18666343373" className="text-xs text-brand-gray-400 hover:text-brand-teal transition-colors" data-id="element-130">
                1-866-634-3373
              </a>
            </div>
          </div>
        </div>}
    </>;
}